/* Lissée Paris — winkelmandlade, 14 september 2026 (Ruben). Vervangt lissee-upcart.js en UpCart.
   Alle knoppen in sections/cart-drawer.liquid werken via dit bestand:
   1. − / + per artikel  → zet het aantal-veld en stuurt een change-event; <line-item-quantity> van het thema doet de rest.
   2. Code promo         → cart/update.js met { discount }, sinds mei 2025 ondersteund door Shopify. Ongeldig = melding, code weer weg.
   3. Complétez votre look → kleur/maat kiezen, cart/add.js, daarna cart:change zodat de lade zichzelf ververst.
   4. Hartjes            → dezelfde favorietenlijst als de rest van de site (lissee-wishlist.js); na elke verversing opnieuw gesynchroniseerd.
   Alles is gedelegeerd op document, omdat theme.js de inhoud van de lade bij elke wijziging opnieuw inzet. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.getElementById('cart-drawer'); }

  function announce(cart, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: baseEvent, cart: cart }
    }));
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    });
  }

  /* 1. Aantal − / + ------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lissee-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('line-item-quantity');
    var input = wrap && wrap.querySelector('input[data-line-key]');
    if (!input || wrap.getAttribute('aria-busy') === 'true') return;

    var step = parseInt(btn.getAttribute('data-lissee-qty-step'), 10) || 0;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 1;
    var next = current + step;
    var max = parseInt(input.getAttribute('max'), 10);
    if (next < 0) return;
    if (!isNaN(max) && next > max) { btn.classList.add('is-max'); setTimeout(function () { btn.classList.remove('is-max'); }, 600); return; }

    wrap.setAttribute('aria-busy', 'true');
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    if (document.activeElement === input) input.blur(); /* geen blauwe selectie van het getal na een klik op − of + (Ruben 21:20) */
  });

  document.addEventListener('line-item:change', function (e) {
    var wrap = e.target && e.target.querySelector && e.target.querySelector('line-item-quantity');
    if (wrap) wrap.removeAttribute('aria-busy');
  });

  /* 2. Code promo --------------------------------------------------------- */
  function codesOf(form) {
    return (form.getAttribute('data-lissee-discount') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }

  function setDiscount(codes) {
    return postJSON(root + 'cart/update.js', { discount: codes.join(','), sections: ['cart-drawer'] });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-lissee-discount]');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('input[name="discount"]');
    var btn = form.querySelector('button[type="submit"]');
    var error = form.parentNode.querySelector('[data-lissee-discount-error]');
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }

    var existing = codesOf(form);
    var wanted = existing.filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); }).concat([code]);

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    input.removeAttribute('aria-invalid');

    setDiscount(wanted).then(function (r) {
      var applied = r.ok && (r.json.discount_codes || []).some(function (d) {
        return d.applicable && String(d.code).toLowerCase() === code.toLowerCase();
      });
      if (applied) {
        announce(r.json, 'discount:change');
        return;
      }
      /* Ongeldig: melding tonen en de code weer uit de winkelmand halen, anders blijft hij hangen tot in de checkout. */
      if (error) error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      input.focus();
      return setDiscount(existing);
    }).catch(function () {
      if (error) { error.textContent = 'Une erreur est survenue. Veuillez réessayer.'; error.hidden = false; }
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
  });

  document.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('[data-lissee-discount-remove]');
    if (!x) return;
    var form = x.closest('.lissee-cart__discount').querySelector('[data-lissee-discount]');
    var remove = x.getAttribute('data-lissee-discount-remove').toLowerCase();
    var remaining = codesOf(form).filter(function (c) { return c.toLowerCase() !== remove; });
    x.disabled = true;
    setDiscount(remaining).then(function (r) {
      if (r.ok) announce(r.json, 'discount:change'); else x.disabled = false;
    }).catch(function () { x.disabled = false; });
  });

  /* 3. Complétez votre look ------------------------------------------------ */
  function initXsell(scope) {
    var items = (scope || document).querySelectorAll('.lissee-cx__item:not([data-ready])');
    Array.prototype.forEach.call(items, function (item) {
      item.setAttribute('data-ready', '1');
      var data;
      try { data = JSON.parse(item.querySelector('.lissee-cx__data').textContent); } catch (err) { return; }
      var sels = Array.prototype.slice.call(item.querySelectorAll('.lissee-cx__opt'));
      var btn = item.querySelector('[data-cx-add]');
      if (!btn) return;

      function current() {
        var opts = sels.map(function (s) { return s.value; });
        return data.find(function (v) {
          return v.o.every(function (val, i) { return i >= opts.length || val === opts[i]; });
        });
      }
      function refresh() {
        var v = current();
        var ok = !!(v && v.a);
        btn.disabled = !ok;
        btn.textContent = ok ? '+ Ajouter' : 'Épuisé';
      }

      var first = data.find(function (v) { return v.a; }) || data[0];
      if (first) first.o.forEach(function (val, i) { if (sels[i]) sels[i].value = val; });
      sels.forEach(function (s) { s.addEventListener('change', refresh); });

      btn.addEventListener('click', function () {
        var v = current();
        if (!v || !v.a) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Ajout…';
        postJSON(root + 'cart/add.js', { items: [{ id: v.id, quantity: 1 }], sections: ['cart-drawer'] })
          .then(function (r) {
            if (!r.ok) throw new Error(r.json.description || 'fout');
            return fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
              cart.sections = r.json.sections;
              announce(cart, 'variant:add');
            });
          })
          .catch(function () {
            btn.textContent = 'Erreur';
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            setTimeout(refresh, 1800);
          });
      });

      refresh();
    });
  }

  /* 3b. Pijltjes bij "Complétez votre look": heen en terug scrollen met de muis (Ruben 21:08) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cx-scroll]');
    if (!btn) return;
    var box = btn.closest('.lissee-cx');
    var list = box && box.querySelector('.lissee-cx__list');
    var item = list && list.querySelector('.lissee-cx__item');
    if (!list || !item) return;
    var step = item.getBoundingClientRect().width + 12;
    list.scrollBy({ left: step * parseInt(btn.getAttribute('data-cx-scroll'), 10), behavior: 'smooth' });
  });
  function updateArrows(box) {
    var list = box.querySelector('.lissee-cx__list'); if (!list) return;
    var prev = box.querySelector('[data-cx-scroll="-1"]'), next = box.querySelector('[data-cx-scroll="1"]');
    if (prev) prev.disabled = list.scrollLeft <= 2;
    if (next) next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  }
  document.addEventListener('scroll', function (e) {
    var list = e.target && e.target.classList && e.target.classList.contains('lissee-cx__list') ? e.target : null;
    if (list) updateArrows(list.closest('.lissee-cx'));
  }, true);

  /* 4. Na elke verversing: hartjes en kaarten opnieuw koppelen -------------- */
  var syncTimer = null;
  function sync() {
    syncTimer = null;
    var d = drawer();
    if (!d) return;
    initXsell(d);
    Array.prototype.forEach.call(d.querySelectorAll('.lissee-cx'), updateArrows);
    if (window.LisseeWishlist && typeof window.LisseeWishlist.sync === 'function') window.LisseeWishlist.sync();
  }
  function scheduleSync() {
    if (syncTimer) return;
    syncTimer = setTimeout(sync, 60);
  }

  /* 5. Niet sluiten op een klik die geen mens deed ------------------------------
     Gevonden 14 sep 2026 met Ruben: de lade ging 1,5 s na het openen vanzelf dicht. Oorzaak: het openen
     zet de pagina op slot, de carrousel van het voordelenblok (static-text-with-icons) meldt daardoor een
     "carousel:change", en page-dots klikt programmatisch op zijn eigen knop. Die kunstmatige klik ligt
     buiten de lade, en de focus-trap van het thema sluit dan de lade. Echte klikken buiten de lade
     blijven gewoon sluiten. */
  function guardOutsideClick(d) {
    if (!d || d.__lisseeGuarded || typeof d._allowOutsideClickMouse !== 'function') return;
    d.__lisseeGuarded = true;
    var original = d._allowOutsideClickMouse.bind(d);
    d._allowOutsideClickMouse = function (event) {
      if (event && event.isTrusted === false) return true;
      return original(event);
    };
  }

  /* 6. De lade zelf mag nooit opzij schuiven (Ruben 21:15): alleen de kaartenrij scrolt horizontaal.
     Extra vangnet naast de CSS: schuift de body van de lade toch opzij (veeg, focus op een keuzelijst), dan
     meteen terug naar 0. */
  function guardBodyScroll(d) {
    var body = d.shadowRoot && d.shadowRoot.querySelector('[part="body"]');
    if (!body || body.__lisseeGuarded) return;
    body.__lisseeGuarded = true;
    body.style.overflowX = 'hidden';
    body.addEventListener('scroll', function () { if (body.scrollLeft !== 0) body.scrollLeft = 0; }, { passive: true });
    d.addEventListener('dialog:after-show', function () { body.scrollLeft = 0; });
  }

  function init() {
    var d = drawer();
    if (!d) return;
    guardOutsideClick(d);
    guardBodyScroll(d);
    if (!d.shadowRoot) { var t = setInterval(function () { if (d.shadowRoot) { clearInterval(t); guardBodyScroll(d); } }, 200); setTimeout(function () { clearInterval(t); }, 10000); }
    new MutationObserver(scheduleSync).observe(d, { childList: true, subtree: true });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('lissee:wishlist:change', scheduleSync);
})();
